module.exports = __webpack_public_path__ + "static/media/21.29a2a12e.jpeg";